import React from "react";
import {formatMoney} from "../../../../../core/services/utils/utils";

const FixTransactionDialogFinancialSummary = ({
                                                  amount,
                                                  balance,
                                              }) => {
    return (
        <>
            <div className={'d-flex justify-content-end px-2 mt-2'}>
                <div className={'border-top pl-1 pt-1 pb-1'}>
                    {/*TOTAL INVOICES*/}
                    <div className={'px-3 py-1 rounded-xl d-flex' +
                        ' justify-content-between align-items-center'}>
                        <p className={'text-sm text-color-1'}>
                            Amount:
                        </p>
                        <span
                            className={'ml-2 text-md secondary-color-1 font-weight-bold'}>
                            {
                                formatMoney(amount)
                            }
                        </span>
                    </div>
                    <div className={'w-100 my-2'}/>
                    {/*TOTAL*/}
                    <div className={'px-3 py-3 background-secondary-color-4 rounded-xl d-flex justify-content-between' +
                        ' align-items-center'}>
                        <p className={'text-sm text-color-1'}>
                            Balance:
                        </p>
                        <span
                            className={'ml-2 text-md secondary-color-1 font-weight-bold'}>
                            {
                                formatMoney(balance)
                            }
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FixTransactionDialogFinancialSummary;
